var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-st-designer',{ref:"designer",on:{"save":_vm.save,"exit":_vm.exit}})}
var staticRenderFns = []

export { render, staticRenderFns }